import { useEligiblePastShiftsByMissionId, } from '../../../../ui/features/shift/hooks/useEligiblePastShiftsByMissionId';
export const useEligiblePastShiftsByMissionIdTableDataProvider = (request, additionalData) => {
    var _a, _b;
    const { isVolunteerView, missionId, missionTypeId } = additionalData;
    const { isLoading, shifts: pastShifts, total, analytics, fetchShifts, error, } = useEligiblePastShiftsByMissionId({
        filterData: additionalData.filterData,
        missionId,
        missionTypeId,
        isVolunteerView,
        offset: (_a = request === null || request === void 0 ? void 0 : request.offset) !== null && _a !== void 0 ? _a : 0,
        limit: (_b = request === null || request === void 0 ? void 0 : request.limit) !== null && _b !== void 0 ? _b : 0,
    });
    const data = {
        filteredRowCount: total,
        rows: pastShifts !== null && pastShifts !== void 0 ? pastShifts : [],
    };
    return {
        data,
        error,
        isLoading,
        reload: fetchShifts,
        customBackendResponseData: {
            analytics: analytics !== null && analytics !== void 0 ? analytics : { totalPendingHours: 0 },
            total: total !== null && total !== void 0 ? total : 0,
        },
    };
};
